// Constants
import Vue from 'vue';
import FormDataService from 'services/form-data.service';
import AddEditMixin from '../shared/AddEditMixin';
import AddEditForm from '../shared/AddEditForm';
import CompanyConstants from '../../constants/column-name/company.column-name.constants';
import CompanyFormConstants from '../../constants/form/company.form.constants';

export default Vue.component('window', {
  template: `  <AddEditForm title='${
    CompanyFormConstants.FormTitle
  }' ref="addEditForm" @submit-button-clicked="onFormSubmit">
      ${FormDataService.textInput(CompanyConstants.code)}
      ${FormDataService.textInput(CompanyConstants.companyName)}
      ${FormDataService.textInput(CompanyConstants.address)}
      <label for="imageUpload" />
      <input class="image-uploader" type="file" id="imageUpload" accept="image/*" ref="file" @change="handleFileUpload()">
      <img id="previewImage" :alt="formData.companyName" :src="previewSrc" v-if="previewSrc !== ''"/>
  </AddEditForm>`,
  name: CompanyFormConstants.FormName,
  data() {
    return {
      formData: {},
      previewSrc: ''
    };
  },
  mixins: [AddEditMixin],
  methods: {
    handleFileUpload() {
      if (this.$refs.file !== undefined) {
        const uploadedFile = this.$refs.file.files[0];
        this.formData.fileExtension = uploadedFile.name.split('.').pop();
        const reader = new FileReader();

        reader.onload = (() => {
          return e => {
            const binaryData = e.target.result;
            const base64String = window.btoa(binaryData);
            this.formData.file = base64String;
          };
        })(uploadedFile);

        reader.readAsBinaryString(uploadedFile);

        const previewReader = new FileReader();
        previewReader.onload = e => {
          this.previewSrc = e.target.result;
        };

        previewReader.readAsDataURL(uploadedFile);
      }
    },
    checkForm() {
      return this.checkFormSubmission(CompanyConstants);
    },
    openDialog(data) {
      this.formData = { ...data };
      this.previewSrc = this.formData.logoPath;
      this.$refs.addEditForm.openDialog(data);
    }
  },
  components: {
    AddEditForm
  }
});
